import { useQuery } from "@apollo/client";
import { graphql } from "gql/apollo";
import {
	DownloadStatusPurpose,
	getDownloadStatusQuery,
} from "gql/apollo/graphql";
import { useMemo } from "react";

export interface DownloadStatus {
	status: string;
	progressPercent: number;
	downloadLink?: string;
	errors: { message: string }[];
	exportedDate: string;
}

export const GetDownloadStatusQuery = graphql(/* GraphQL */ `
	query getDownloadStatus($params: GetDownloadStatusParams!) {
		getDownloadStatus(params: $params) {
			file_url
			download_errors {
				message
			}
			progress {
				percent
			}
			status
			updated
		}
	}
`);

export const useGetDownloadStatus = (
	purpose: DownloadStatusPurpose,
	gid?: GID
) => {
	const { data, loading, startPolling, stopPolling } =
		useQuery<getDownloadStatusQuery>(GetDownloadStatusQuery, {
			variables: {
				params: {
					target_gid: gid!,
					purpose,
				},
			},
			skip: !gid,
		});

	const status = useMemo(
		() =>
			data?.getDownloadStatus ?
				({
					status: data.getDownloadStatus.status,
					progressPercent: data.getDownloadStatus.progress.percent,
					downloadLink: data.getDownloadStatus.file_url ?? undefined,
					errors: data.getDownloadStatus.download_errors,
					exportedDate: data.getDownloadStatus.updated,
				} as DownloadStatus)
			:	undefined,
		[data?.getDownloadStatus]
	);

	return {
		status,
		loading,
		startPolling,
		stopPolling,
	};
};
